import { combineReducers } from 'redux'

import { IPromocodesState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IPromocodesState>({
  communications,
  data,
})
